"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DocumentMenu;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const react_redux_1 = require("react-redux");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const store_1 = require("../../../store");
const user_1 = require("../../../store/selectors/user");
const user_2 = require("../../../slices/user");
const document_1 = require("../../../slices/document");
const useAppMessage_1 = require("../../../hooks/useAppMessage");
const useDocument_1 = __importDefault(require("../../../hooks/useDocument"));
const MenuItem_1 = __importDefault(require("./MenuItem"));
const character_1 = require("../../../services/character");
const document_2 = require("../../../services/document");
const error_1 = require("../../../common/error");
const colors_1 = require("../../../common/colors");
const spacing_1 = require("../../../common/spacing");
const borders_1 = require("../../../common/borders");
function DocumentMenu({ document, sharedDocument, onOpen, onClose, onDelete, onRename, style, ...restProps }) {
    const dispatch = (0, store_1.useAppDispatch)();
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const { showShareLink } = (0, useDocument_1.default)();
    const lastConversation = (0, react_redux_1.useSelector)(user_1.selectLastConversation);
    const lastMessage = (0, react_redux_1.useSelector)(user_1.selectLastMessage);
    const [isMenuHovering, setIsMenuHovering] = (0, react_1.useState)(false);
    const [wasMenuOpened, setWasMenuOpened] = (0, react_1.useState)(false);
    const [isUpdateTitleModalOpen, setIsUpdateTitleModalOpen] = (0, react_1.useState)(false);
    const fadeAnim = react_1.default.useMemo(() => new react_native_1.Animated.Value(0), []);
    react_1.default.useEffect(() => {
        react_native_1.Animated.timing(fadeAnim, {
            toValue: isMenuHovering ? 1 : 0,
            duration: 150,
            useNativeDriver: true,
        }).start();
    }, [isMenuHovering]);
    const handleOnOpen = (0, react_1.useCallback)(() => {
        setWasMenuOpened(true);
        onOpen?.();
    }, [onOpen]);
    const handleOnClose = (0, react_1.useCallback)(() => {
        setWasMenuOpened(false);
        onClose?.();
    }, [onClose]);
    const handleDeleteItem = (0, react_1.useCallback)(async () => {
        if (document) {
            dispatch((0, document_1.setIsLoading)(true));
            const deleteResponse = await (0, document_2.deleteDocument)(document.character.id);
            if (deleteResponse instanceof error_1.APIError) {
                showNotification('Error', deleteResponse.message, 'error');
            }
            else if (deleteResponse instanceof error_1.RequestError) {
                console.error(deleteResponse);
            }
            else {
                await (0, character_1.deleteConversations)(document.conversation.id);
                dispatch((0, user_2.resetCharacter)());
                if (document.conversation.id === lastConversation?.id) {
                    dispatch((0, user_2.resetLastConversation)());
                }
                ;
                if (document.conversation.id === lastMessage?.conversationId.toString()) {
                    dispatch((0, user_2.resetLastMessage)());
                }
                ;
                showNotification('Success', 'Document deleted successfully!', 'success');
                onDelete?.(document);
            }
            dispatch((0, document_1.setIsLoading)(false));
        }
    }, [document, onDelete, dispatch, lastConversation, lastMessage]);
    const handleShareItem = (0, react_1.useCallback)(() => {
        showShareLink(document ?? sharedDocument);
    }, [document, sharedDocument, showShareLink]);
    const handleRenameItem = (0, react_1.useCallback)(() => {
        if (document) {
            setIsUpdateTitleModalOpen(true);
        }
    }, [document, dispatch]);
    const interpolatedBackground = fadeAnim.interpolate({
        inputRange: [0, 1],
        outputRange: ['rgba(18, 18, 24, 0.4)', 'rgba(18, 18, 24, 0.6)']
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(native_base_1.Menu, { closeOnSelect: true, onClose: handleOnClose, onOpen: handleOnOpen, placement: 'bottom right', offset: 12, style: styles.menu, trigger: (triggerProps) => {
                return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onHoverIn: () => setIsMenuHovering(true), onHoverOut: () => setIsMenuHovering(false), style: typeof style === 'function'
                        ? (state) => [style(state)]
                        : [style], ...triggerProps, ...restProps, children: (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: [
                            styles.trigger,
                            { backgroundColor: interpolatedBackground }
                        ], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faEllipsis, color: "white", size: 20 }) }) }));
            }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.itemsContainer, children: [document && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), (0, jsx_runtime_1.jsx)(MenuItem_1.default, { icon: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faShareNodes, color: colors_1.Colors.DARK_200, size: 16 }), action: handleShareItem, children: "Share" }), document && ((0, jsx_runtime_1.jsx)(MenuItem_1.default, { icon: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faTrash, color: colors_1.Colors.red, size: 16 }), action: handleDeleteItem, isDestructive: true, children: "Delete" }))] }) }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    trigger: {
        width: 28,
        height: 28,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 16,
    },
    menu: {
        backgroundColor: colors_1.Colors.DARK_600,
        width: "100%",
        maxWidth: 200,
        paddingVertical: spacing_1.Spacing.SPACING_XS + 1,
        borderRadius: borders_1.Borders.RADIUS_MD,
    },
    itemsContainer: {
        gap: 1,
    },
});
